import template from './RulesContainerView.html';
import { RuleContainerController } from './RuleContainerController';
export const RuleContainerComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: RuleContainerController,
    controllerAs: '$ctrl',
    template: template,
    bindings: {
        data: '<',
        application: '<',
        canEditRule: '<',
        canSeeRule: '<',
        queue: '<',
        onEdit: '&?',
        onDelete: '&?',
        onCancel: '&?',
        onChange: '&?',
        elementId: '@?',
    },
};
